import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapLocationDot, faXmark } from '@fortawesome/free-solid-svg-icons';
import { GoogleMap, LoadScript, Marker, MarkerClusterer } from '@react-google-maps/api';
import HotelCard from '../HotelCard';
import usePricelineStore from '../../../store/hotel/priceline';
import useSearchHooks from '../../../store/hotel/search-hooks';

function MapSeletion() {
  // eslint-disable-next-line no-unused-vars
  const [map, setMap] = React.useState(null);
  const [showMap, SetShowMap] = React.useState(false);
  const [chooseHotel, SetChooseHotel] = React.useState(null);
  const { filterList } = usePricelineStore((state) => ({ filterList: state.filterList }));
  const geo = filterList.length > 0 ? filterList[0].geo : { latitude: 0, longitude: 0 };
  const { search } = useSearchHooks();
  const containerStyle = {
    width: '100%',
    height: '450px',
  };
  const mapStyle = [
    {
      elementType: 'geometry',
      stylers: [
        {
          color: '#212121',
        },
      ],
    },
    {
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#757575',
        },
      ],
    },
    {
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#212121',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [
        {
          color: '#757575',
        },
      ],
    },
    {
      featureType: 'administrative.country',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#9e9e9e',
        },
      ],
    },
    {
      featureType: 'administrative.land_parcel',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#bdbdbd',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#757575',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [
        {
          color: '#181818',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#616161',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#1b1b1b',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#2c2c2c',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#8a8a8a',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry',
      stylers: [
        {
          color: '#373737',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [
        {
          color: '#3c3c3c',
        },
      ],
    },
    {
      featureType: 'road.highway.controlled_access',
      elementType: 'geometry',
      stylers: [
        {
          color: '#4e4e4e',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#616161',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#757575',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [
        {
          color: '#000000',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#3d3d3d',
        },
      ],
    },
  ];
  const center = {
    lat: chooseHotel ? +chooseHotel.geo.latitude : +geo.latitude,
    lng: chooseHotel ? +chooseHotel.geo.longitude : +geo.longitude,
  };
  // eslint-disable-next-line no-shadow
  const onLoad = React.useCallback((map) => {
    map.setOptions({
      styles: mapStyle,
      disableDefaultUI: true,
      zoomControl: true,
    });
    setMap(map);
  }, []);
  const onUnmount = React.useCallback(function callback() {
    setMap(null);
  }, []);

  const showMapToggle = () => {
    if (showMap) SetChooseHotel(null);
    SetShowMap(!showMap);
  };

  const renderClusterer = React.useCallback(
    (clusterer) =>
      filterList.map((location) => {
        const key = location.id;
        const position = { lat: +location.geo.latitude, lng: +location.geo.longitude };
        return (
          <Marker
            key={key}
            position={position}
            clusterer={clusterer}
            label={{ text: `$${location.price_saving}`, color: 'white', className: 'marker-label' }}
            icon="https://foodfan.s3.amazonaws.com/2021/marker.png"
            onClick={() => {
              SetChooseHotel(location);
            }}
          />
        );
      }),
    [filterList]
  );

  if (filterList.length === 0) return null;
  return (
    <div className="content-map-container">
      <button type="button" onClick={() => showMapToggle()}>
        <FontAwesomeIcon icon={faMapLocationDot} className="mx-2" />
        {showMap ? 'Hide Map' : 'Show Map'}
      </button>
      <div
        className="map"
        style={{
          height: showMap ? 'auto' : '0px',
          display: showMap ? 'block' : 'none',
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <LoadScript googleMapsApiKey="AIzaSyB_fAgWY2Gqp3CCbl6sl_3SlovkuK-y67k">
          <GoogleMap styles={mapStyle} onLoad={onLoad} mapContainerStyle={containerStyle} scrollwheel={false} defaultMapTypeId="google.maps.MapTypeId.ROADMAP" center={center} onUnmount={onUnmount} zoom={10} defaultStyles={mapStyle}>
            <MarkerClusterer>{renderClusterer}</MarkerClusterer>
          </GoogleMap>
        </LoadScript>
      </div>
      <div className="map-detail">
        {chooseHotel ? (
          <div className="map-detail-show">
            <HotelCard hotel={chooseHotel} queryParameter={search} />
            <div className="close-map-detail">
              <FontAwesomeIcon icon={faXmark} className="mx-2" onClick={() => SetChooseHotel(null)} />{' '}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}

export default React.memo(MapSeletion);
